module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/HU-fcf69131f5ea70d252cba366f64aaede.png";